import { MouseEvent } from 'react'

export function stopClickPropagation(event: MouseEvent) {
  event.stopPropagation()
}
